import type { DependencyContainer } from 'tsyringe';
import type { DpProvider } from '@/core/di/DpProvider';
import { EventTrackerFacade } from '@/common/tracking-event/public/api';
import type { EventTracker } from '@/modules/timeline/domain/tracking/EventTracker';
import { EventTrackerToken } from '@/modules/timeline/di/tokens';

export class TrackingProvider implements DpProvider {
  register(container: DependencyContainer): void {
    container.register<EventTracker>(EventTrackerToken, EventTrackerFacade);
  }
}
